import { getFontWeight, styled } from '@core-ui/react-stitch';

const ErrorMessageDivision = styled.div(({ theme, isBRRedesignEnabled }) => ({
  color: isBRRedesignEnabled ? theme.color.wh : theme.color.g1,
  ...theme.brandFont,
  ...getFontWeight('regular'),
  fontSize: '0.875rem',
  textAlign: 'center',
  padding: '2rem 0 2rem 0.5rem',
  textTransform: 'inherit',
  '@media (min-width: 768px)': {
    fontSize: '120%',
    width: '100%',
  },
  '@media (min-width: 1024px)': {
    textAlign: 'left',
    maxWidth: '768px',
  },
  ...theme.fontSize,
}));

export default ErrorMessageDivision;
